import { render, staticRenderFns } from "./NewsArrived.vue?vue&type=template&id=20e92156&scoped=true"
import script from "./NewsArrived.vue?vue&type=script&lang=js"
export * from "./NewsArrived.vue?vue&type=script&lang=js"
import style0 from "./NewsArrived.vue?vue&type=style&index=0&id=20e92156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e92156",
  null
  
)

export default component.exports